<script>
    import * as Common from '../Common.js'

    let generalFeeback = {
        email: '',
        content: ''
    }

    function submit() {
        if(generalFeeback.email.length == 0 ||
        generalFeeback.content.length == 0) {
            alert("Please fill out all fields in the contact form.")
            return
        }

        Common.postData('generalfeedback', generalFeeback)
        .then(r => {
            if(!r.ok) {
                alert("Problem with your submission.")
                return
            }
            alert("Thank you, your message will be reviewed.")
            generalFeeback.email = ''
            generalFeeback.content = ''
        })
    }
</script>

<div>
    <input type="email" bind:value={generalFeeback.email} placeholder="Email"/><br>
    <textarea style="width: 80%; height: 100px" bind:value={generalFeeback.content} placeholder="Message"></textarea><br>
    <button class="submit" on:click={submit}>Submit</button>
</div>